/*
 * tbh-search.js  (Oct 2026) — The Bike Affair's own search, on the storefront.
 *
 * Two jobs, one file, because both need the same API and the same helpers:
 *
 *  1. THE HEADER BOX. The theme's <predictive-search> element asks Shopify for suggestions
 *     as you type. Its getResults() is swapped for one that asks our API
 *     (/search/suggest) and renders the SAME markup the theme's Liquid section renders, so
 *     the dropdown looks and behaves exactly as before (tabs, arrow keys, "View all"). If
 *     our API fails, the theme's original method runs — Shopify's dropdown is the fallback.
 *
 *  2. THE RESULTS PAGE. sections/tba-search-results.liquid is a shell: this script asks
 *     /search/products for the ranked page, facets and corrections, then asks SHOPIFY to
 *     render the cards — the section tba-card-renderer takes the handles (through
 *     search.terms, the only query string Liquid can read) and renders the theme's real
 *     product-card snippet for each, so prices, badges, swatches and the "sizes in stock"
 *     chips are live and identical to every other grid on the site. If anything fails the
 *     theme's own search section (hidden until then) is shown instead.
 *
 * Added 2026-10-07 (the "all 11" pass): the empty box (popular, your recent searches, what
 * is selling, "Set my bike"), guides and pages beside the products, owner redirects, a
 * compatibility note and spec facts under the cards, the "For my bike" chip, "Ask TBA Guide"
 * on a miss, and the add-to-cart that followed a search reported to /search/convert. The
 * bike and the recent searches live in this browser only (localStorage); the API gets a few
 * hints (speeds, wheel size, frame size) and never an identity.
 *
 * API base: data-api on the script tag (Theme settings → TBA search). For local work the
 * page may be opened with ?tbh_api=http://localhost:8787, remembered for the tab session.
 * Nothing here reads cookies or customer data; clicks are reported with the query and the
 * product id only, so popular products can rank higher for that query.
 */
(function () {
  if (window.__tbhSearch) return;
  window.__tbhSearch = true;

  var script = document.currentScript;
  var qs = new URLSearchParams(location.search);
  var override = qs.get('tbh_api');
  try { if (override) sessionStorage.setItem('tbh_api', override); } catch (e) { /* private mode */ }
  var api = override || (function () { try { return sessionStorage.getItem('tbh_api'); } catch (e) { return null; } })() || (script && script.getAttribute('data-api')) || '';
  api = String(api).replace(/\/$/, '');
  if (!api) return;
  // A search "in" a collection arrives from the box on a collection page (snippets/
  // tbh-collection-search.liquid): /search?q=…&collection=<handle>&ct=<title>.
  var pageCollection = (qs.get('collection') || '').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 120);
  var pageCollectionTitle = (qs.get('ct') || '').slice(0, 120);
  function collectionName(d) {
    var c = d && d.collection;
    return (c && c.title) || pageCollectionTitle || pageCollection.replace(/-/g, ' ').replace(/^./, function (ch) { return ch.toUpperCase(); });
  }

  // ---- helpers ------------------------------------------------------------
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { if (n == null) return ''; try { return '₹' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 }); } catch (e) { return '₹' + Math.round(n); } }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  function split(v) { return v ? String(v).split('|').filter(Boolean) : []; }
  function fetchJSON(path, params, ms) {
    var u = new URL(api + path);
    Object.keys(params || {}).forEach(function (k) { var v = params[k]; if (v != null && v !== '' && v !== false) u.searchParams.set(k, v); });
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms || 4000) : null;
    return fetch(u.toString(), { signal: ctrl ? ctrl.signal : undefined, credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .finally(function () { if (timer) clearTimeout(timer); });
  }
  // A BEACON MUST NEED NO PREFLIGHT. The first cut sent a Blob typed application/json: not a
  // CORS-safelisted type, so the browser preflights it, and a beacon is credentialed by the
  // spec, so that preflight failed on the API's CORS answer and the POST was never sent at
  // all -- 53 searches and 0 clicks on the live site (Sampath, 2026-10-07). A plain string
  // goes as text/plain, which needs no preflight; the API reads the body as JSON regardless.
  function post(path, obj) {
    var body = JSON.stringify(obj), url = api + path;
    try { if (navigator.sendBeacon && navigator.sendBeacon(url, body)) return; } catch (e) { /* fall through to fetch */ }
    try { fetch(url, { method: 'POST', body: body, keepalive: true, credentials: 'omit', headers: { 'content-type': 'text/plain;charset=UTF-8' } }).catch(function () {}); } catch (e) { /* a lost click is nothing */ }
  }
  function beacon(q, id, position) { post('/search/click', { q: q, id: String(id), position: position || null }); }
  var ARROW = '<svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M4.696 12h14.686m-7.343-7.343L19.382 12l-7.343 7.343"/></svg>';
  // This browser's memory: recent searches and the saved bike. Nothing here leaves the device
  // except the bike's speeds, wheel size and frame size, sent as plain hints with a search.
  function readJSON(store, key, fallback) { try { var v = store.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; } }
  function writeJSON(store, key, val) { try { if (val == null) store.removeItem(key); else store.setItem(key, JSON.stringify(val)); } catch (e) { /* private mode */ } }
  function recentSearches() { var r = readJSON(localStorage, 'tbh-recent', []); return Array.isArray(r) ? r.filter(function (x) { return typeof x === 'string'; }).slice(0, 6) : []; }
  function rememberSearch(term) {
    term = String(term || '').trim().slice(0, 80); if (!term) return;
    var r = recentSearches().filter(function (x) { return x.toLowerCase() !== term.toLowerCase(); });
    r.unshift(term); writeJSON(localStorage, 'tbh-recent', r.slice(0, 6));
  }
  // A saved bike is one we sell (handle), one from the outside-bike library (id) or one the
  // shopper typed (source 'typed'): all three carry a title and the same fit facts.
  function myBike() { var b = readJSON(localStorage, 'tbh-bike', null); return b && b.title ? b : null; }
  function saveBike(b) { writeJSON(localStorage, 'tbh-bike', b); document.dispatchEvent(new CustomEvent('tbh:bike', { detail: b })); }
  function bikeHints(b) {
    if (!b) return {};
    return { bike_speeds: (b.speeds || []).join(','), bike_wheel: b.wheel || '', bike_size: b.size || '', bike_brakes: b.brakes || '' };
  }
  function askGuideHref(term) { return location.pathname + '?tba-chat=' + encodeURIComponent('Do you have ' + term + '?'); }
  // THE SEARCH THAT LED TO THE CART. A result click remembers the search for half an hour;
  // the theme's own on:cart:add event then reports the pair, so the console can say which
  // searches sell and not only which get clicked. The product id is the one clicked.
  function rememberClick(term, id) { writeJSON(sessionStorage, 'tbh-last-search', { q: term, id: String(id), at: Date.now() }); }
  document.addEventListener('on:cart:add', function (ev) {
    var last = readJSON(sessionStorage, 'tbh-last-search', null);
    if (!last || !last.q || Date.now() - (last.at || 0) > 30 * 60 * 1000) return;
    var variantId = ev.detail && (ev.detail.variantId || ev.detail.variant_id || ev.detail.id) || null;
    post('/search/convert', { q: last.q, id: last.id, variantId: variantId ? String(variantId) : null });
    writeJSON(sessionStorage, 'tbh-last-search', null);
  }, true);

  // ---- 1. the header dropdown ----------------------------------------------
  // The dropdown's styles ride with the script, because the script runs on EVERY page (the
  // header box) while tbh-search.css loads only on the results page. The theme gives the list
  // a max-height and no overflow rule, so with ten products it drew past the panel's bottom
  // edge onto the page (Sampath, 2026-10-07).
  (function () {
    if (document.getElementById('tbh-search-dropdown-css')) return;
    var s = document.createElement('style');
    s.id = 'tbh-search-dropdown-css';
    s.textContent = '.predictive-search .predictive-search__scroller{max-height:min(72vh,720px);overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}' +
      '.predictive-result__price{font-size:13px;font-weight:600;margin-top:2px}' +
      '.tbh-sf__off{font-weight:600;font-size:12px;color:var(--tbh-accent,#f59523);margin-left:4px}' +
      '.predictive-result mark{background:none;color:var(--tbh-ink,#111);font-weight:700;text-decoration:underline;text-underline-offset:3px}' +
      // below the desktop column breakpoint the suggestions block sits tight above the tabs: a
      // heading, one line per suggestion, no air; from 1024px the theme lays it out as a column
      '@media (max-width:1023.98px){' +
        '.predictive-search__suggestions{padding-top:0!important;padding-bottom:2px}' +
        '.predictive-result__list-suggestions .predictive-result__title{margin-top:10px!important;margin-bottom:0!important;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:var(--tbh-muted,#6b6b6b)}' +
        '.predictive-result--suggestion{padding-top:7px!important;padding-bottom:7px!important}' +
      '}' +
      '.predictive-search .tablist__scroller{padding:2px 0!important}' +
      '.predictive-search__tabpanel{margin-top:2px!important}' +
      // the empty box: small headings, chips, a short product list, the bike row
      // the theme pads each dropdown ITEM by the page gutter (36px from tablet up); the empty
      // box's own blocks follow it, and the product list inside gives its own padding back
      '.tbh-eb{padding:4px var(--gutter,20px) 6px}' +
      '@media (min-width:769px){.tbh-eb{padding-left:36px;padding-right:36px}}' +
      '.tbh-eb .predictive-result{padding-left:0!important;padding-right:0!important}' +
      '.tbh-eb__h{margin:10px 0 6px;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:var(--tbh-muted,#6b6b6b)}' +
      '.tbh-eb__chips{display:flex;flex-wrap:wrap;gap:6px;margin:0;padding:0 0 4px;list-style:none}' +
      '.tbh-eb__chip{display:inline-block;border:1px solid #d5d8dc;border-radius:999px;padding:5px 11px;font-size:13px;line-height:1.3;color:#3f3f3f;background:#fff;text-decoration:none;white-space:nowrap}' +
      '.tbh-eb__chip:hover{border-color:#3f3f3f;color:#111}' +
      '.tbh-eb__bike{display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin:8px 0 2px;padding:9px 12px;border:1px solid #e3e5e8;border-radius:8px;font-size:13px}' +
      '.tbh-eb__bike b{font-weight:600}.tbh-eb__bike .link{font-size:13px}' +
      '.tbh-eb__bikeicon{flex:0 0 auto;width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;color:var(--tbh-muted,#6b6b6b)}' +
      '.tbh-eb__bike>span{flex:1 1 auto;min-width:0}' +
      '.tbh-eb__bike select{font:inherit;font-size:13px;padding:3px 6px;border:1px solid #d5d8dc;border-radius:6px;background:#fff}' +
      '.tbh-eb__pick{flex:1 1 100%;display:flex;flex-direction:column;gap:6px}' +
      '.tbh-eb__pick input{font:inherit;font-size:14px;padding:8px 10px;border:1px solid #d5d8dc;border-radius:6px;width:100%}' +
      '.tbh-eb__pick ul{list-style:none;margin:0;padding:0;max-height:220px;overflow:auto}' +
      '.tbh-eb__pick button{display:block;width:100%;text-align:left;font:inherit;font-size:13px;padding:7px 8px;border:0;border-radius:6px;background:none;cursor:pointer}' +
      '.tbh-eb__pick button:hover{background:#f3f4f6}.tbh-eb__pick small{color:var(--tbh-muted,#6b6b6b)}' +
      '.tbh-eb__pick li.tbh-eb__grp{font-size:11px;letter-spacing:.04em;text-transform:uppercase;color:var(--tbh-muted,#6b6b6b);padding:6px 8px 2px}' +
      '.tbh-eb__pick .tbh-eb__facts{display:block;font-size:12px;color:var(--tbh-muted,#6b6b6b)}' +
      '.tbh-eb__picks{display:flex;flex-wrap:wrap;gap:8px;align-items:flex-end}.tbh-eb__picks label{display:flex;flex-direction:column;gap:3px;font-size:12px;color:var(--tbh-muted,#6b6b6b)}' +
      '.tbh-eb__picks select{font:inherit;font-size:13px;padding:5px 6px;border:1px solid #d5d8dc;border-radius:6px;background:#fff;color:inherit}' +
      '.tbh-eb__picks .tbh-eb__save{font:inherit;font-size:13px;font-weight:600;padding:6px 14px;border:0;border-radius:6px;background:#111;color:#fff;cursor:pointer}' +
      '.tbh-sf__kind{display:inline-block;margin-right:6px;font-size:11px;letter-spacing:.04em;text-transform:uppercase;color:var(--tbh-muted,#6b6b6b)}';
    (document.head || document.documentElement).appendChild(s);
  })();
  var suggestCache = {};
  function renderSuggest(d, id, term) {
    var queries = [];
    if (d.corrected) queries.push({ url: '/search?q=' + encodeURIComponent(d.corrected), html: 'Did you mean <mark>' + esc(d.corrected) + '</mark>?' });
    (d.queries || []).forEach(function (x) { queries.push({ url: x.url, html: esc(x.text) }); });

    var panels = [];
    if (d.products && d.products.length) {
      var items = d.products.map(function (p, i) {
        // no brand line: every title here starts with the brand (Sampath, 2026-10-07)
        var sub = [];
        if (p.available === false) sub.push('Sold out');
        return '<li class="predictive-search__item" role="option">' +
          '<a class="predictive-result flex items-start focus-inset js-search-link" href="' + esc(p.url) + '" data-tbh-click="' + esc(p.id) + '" data-tbh-pos="' + (i + 1) + '" data-tbh-q="' + esc(term) + '">' +
            '<div class="predictive-result__media media relative">' + (p.image ? '<img src="' + esc(img(p.image, 112)) + '" alt="" width="56" height="56" loading="eager" class="predictive-result__media">' : '') + '</div>' +
            '<div class="predictive-result__info flex-auto">' +
              '<h3 class="predictive-result__title h6">' + esc(p.title) + '</h3>' +
              '<div class="predictive-result__price">' + money(p.price_min) + (p.on_sale && p.discount_pct ? ' <span class="tbh-sf__off">−' + esc(p.discount_pct) + '%</span>' : '') + '</div>' +
              (sub.length ? '<div class="predictive-result__sub-title text-sm">' + sub.join(' · ') + '</div>' : '') +
            '</div></a></li>';
      }).join('');
      items += '<li class="predictive-search__item js-submit" role="option"><button class="predictive-search__view-all link w-full text-start focus-inset has-ltr-icon js-search-link">View all results' + ARROW + '</button></li>';
      panels.push({ key: 'products', label: 'Products', items: items });
    }
    var cats = (d.types || []).map(function (t) {
      return '<li class="predictive-search__item" role="option"><a class="predictive-result flex items-start focus-inset js-search-link" href="' + esc(t.url) + '"><div class="predictive-result__info flex-auto"><h3 class="predictive-result__title h6">' + esc(t.name) + '</h3><div class="predictive-result__sub-title text-sm">' + esc(t.count) + ' products</div></div></a></li>';
    }).concat((d.vendors || []).map(function (v) {
      return '<li class="predictive-search__item" role="option"><a class="predictive-result flex items-start focus-inset js-search-link" href="' + esc(v.url) + '"><div class="predictive-result__info flex-auto"><h3 class="predictive-result__title h6">' + esc(v.name) + '</h3><div class="predictive-result__sub-title text-sm">Brand · ' + esc(v.count) + ' products</div></div></a></li>';
    }));
    if (cats.length) panels.push({ key: 'categories', label: 'Categories & brands', items: cats.join('') });
    // Guides, pages and policies that match: the words the catalogue cannot answer with a product.
    var guides = (d.guides || []).map(function (g) {
      return '<li class="predictive-search__item" role="option"><a class="predictive-result flex items-start focus-inset js-search-link" href="' + esc(g.url) + '"><div class="predictive-result__info flex-auto"><h3 class="predictive-result__title h6"><span class="tbh-sf__kind">' + esc(g.kind) + '</span>' + esc(g.title) + '</h3>' + (g.snippet ? '<div class="predictive-result__sub-title text-sm">' + esc(g.snippet) + '</div>' : '') + '</div></a></li>';
    });
    if (guides.length) panels.push({ key: 'guides', label: 'Guides & pages', items: guides.join('') });

    // The theme's own markup marks a scroller that carries search suggestions: with products
    // too, the header's stylesheet (search-suggestions.css) puts the suggestions in a 222px
    // column on the RIGHT from 1024px up; alone, they are the whole dropdown. Without the class
    // they stacked on top (Sampath, 2026-10-07: "aren't we showing suggestions on the right?").
    var scrollerClass = 'predictive-search__scroller overflow-auto' + (queries.length ? (panels.length ? ' predictive-search__scroller--suggestions' : ' predictive-search__scroller--suggestions-only') : '');
    var html = '<div class="predictive-search absolute bg-theme-bg text-theme-text text-start"><div class="' + scrollerClass + '"><div class="predictive-search__results flex flex-col">';
    if (queries.length) {
      html += '<div class="predictive-search__suggestions relative pt-2 md:pt-0"><ul class="predictive-search__list predictive-result__list-suggestions" role="list">' +
        '<h3 class="predictive-result__title h6 tablist__scroller font-body regular-text font-bold mt-3">Suggestions</h3>' +
        queries.map(function (x) { return '<li class="predictive-search__item" role="option"><a class="predictive-result predictive-result--suggestion block focus-inset js-search-link" href="' + esc(x.url) + '">' + x.html + '</a></li>'; }).join('') +
        '</ul></div>';
    }
    if (panels.length) {
      html += '<tabbed-content class="grow"><div class="tablist relative overflow-hidden bg-theme-bg mb-2"><div class="tablist__scroller flex" role="tablist">' +
        panels.map(function (p, i) { return '<button type="button" class="tablist__tab font-bold" id="' + id + '-' + p.key + '-tab" role="tab"' + (i ? ' tabindex="-1"' : '') + ' aria-controls="' + id + '-' + p.key + '" aria-selected="' + (i ? 'false' : 'true') + '">' + p.label + '</button>'; }).join('') +
        '</div></div>' +
        panels.map(function (p, i) { return '<div class="predictive-search__tabpanel focus-inset" id="' + id + '-' + p.key + '" role="tabpanel" tabindex="0" aria-labelledby="' + id + '-' + p.key + '-tab"' + (i ? ' hidden' : '') + '><ul class="predictive-search__list" role="list">' + p.items + '</ul></div>'; }).join('') +
        '</tabbed-content>';
    } else if (!queries.length) {
      html += '<div class="predictive-search__no-results">No results for “' + esc(term) + '”. Try another word, <a class="link" href="/search?q=' + encodeURIComponent(term) + '">search anyway</a>, or <a class="link" href="' + esc(askGuideHref(term)) + '">ask TBA Guide</a>.</div>';
    }
    return html + '</div></div></div>';
  }

  // ---- the empty box ---------------------------------------------------------
  // Focus on an empty box used to show nothing. Now: your recent searches, what others
  // search, what is selling, and your bike. The theme's element closes on an empty query
  // (its handleInput, debounced 300 ms), so the empty state is re-shown just after.
  var emptyCache = { at: 0, data: null };
  function wheelLabel(w) { return w === '700' ? '700c' : w === '650' ? '650b' : w + '"'; }
  var BIKE_ICON = '<svg class="tbh-eb__bikeicon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="5.5" cy="17.5" r="3.5"/><circle cx="18.5" cy="17.5" r="3.5"/><path d="M5.5 17.5l4-7h5.5l3.5 7M9.5 10.5l3 7 2.5-7M15 10.5l-1-3h2.5"/></svg>';
  function bikeRow(b) {
    if (b) {
      var sizes = sortSizes(b.sizes || []);
      return '<div class="tbh-eb__bike" data-tbh-bike-row>' + BIKE_ICON + '<span>Your bike: <b>' + esc(b.title) + '</b>' +
        (b.speeds && b.speeds.length ? ' · ' + esc(b.speeds.join('/')) + '-speed' : '') + (b.wheel ? ' · ' + esc(wheelLabel(b.wheel)) : '') +
        (b.brakes ? ' · ' + esc(b.brakes) + ' brakes' : '') + '</span>' +
        (sizes.length ? '<label>Frame size <select data-tbh-bike-size><option value="">—</option>' + sizes.map(function (s) { return '<option value="' + esc(s) + '"' + (b.size === s ? ' selected' : '') + '>' + esc(s.toUpperCase()) + '</option>'; }).join('') + '</select></label>' : '') +
        '<a class="link" href="#" data-tbh-bike-change>Change</a><a class="link" href="#" data-tbh-bike-clear>Remove</a></div>';
    }
    return '<div class="tbh-eb__bike" data-tbh-bike-row>' + BIKE_ICON + '<span>Tell us your bike. Parts that fit it will be shown first.</span><a class="link" href="#" data-tbh-bike-change>Set my bike</a></div>';
  }
  function renderEmptyBox(d) {
    var html = '<div class="predictive-search absolute bg-theme-bg text-theme-text text-start"><div class="predictive-search__scroller"><div class="predictive-search__results flex flex-col"><div class="tbh-eb">';
    var recent = recentSearches();
    if (recent.length) html += '<h3 class="tbh-eb__h">Your recent searches</h3><ul class="tbh-eb__chips">' + recent.map(function (r) { return '<li><a class="tbh-eb__chip js-search-link" href="/search?q=' + encodeURIComponent(r) + '">' + esc(r) + '</a></li>'; }).join('') + '</ul>';
    var popular = (d && d.popular || []).filter(function (x) { return recent.indexOf(x.text) < 0; }).slice(0, 8);
    if (popular.length) html += '<h3 class="tbh-eb__h">Popular right now</h3><ul class="tbh-eb__chips">' + popular.map(function (x) { return '<li><a class="tbh-eb__chip js-search-link" href="' + esc(x.url) + '">' + esc(x.text) + '</a></li>'; }).join('') + '</ul>';
    // the bike row needs a backend that knows /search/bike: the new empty-box answer carries
    // `popular`, an older one does not, so the row waits for the deploy (or shows a saved bike)
    if ((d && Array.isArray(d.popular)) || myBike()) html += bikeRow(myBike());
    // what is selling comes last (Sampath, 2026-10-07: "move selling this month to bottom")
    var trending = (d && d.trending || []).slice(0, 4);
    if (trending.length) {
      html += '<h3 class="tbh-eb__h">Selling this month</h3><ul class="predictive-search__list" role="list">' + trending.map(function (p, i) {
        return '<li class="predictive-search__item" role="option"><a class="predictive-result flex items-start focus-inset js-search-link" href="' + esc(p.url) + '" data-tbh-click="' + esc(p.id) + '" data-tbh-pos="' + (i + 1) + '" data-tbh-q="">' +
          '<div class="predictive-result__media media relative">' + (p.image ? '<img src="' + esc(img(p.image, 112)) + '" alt="" width="56" height="56" loading="lazy" class="predictive-result__media">' : '') + '</div>' +
          '<div class="predictive-result__info flex-auto"><h3 class="predictive-result__title h6">' + esc(p.title) + '</h3><div class="predictive-result__price">' + money(p.price_min) + '</div></div></a></li>';
      }).join('') + '</ul>';
    }
    return html + '</div></div></div></div>';
  }
  // sizes in the order a rider reads them, not the alphabet's
  var SIZE_ORDER = ['xxs', 'xs', 's', 'sm', 'm', 'md', 'ml', 'l', 'lg', 'xl', 'xxl', '2xl', '3xl'];
  function sortSizes(list) {
    return list.slice().sort(function (a, b) {
      var i = SIZE_ORDER.indexOf(a), j = SIZE_ORDER.indexOf(b);
      if (i < 0 && j < 0) return String(a).localeCompare(String(b), undefined, { numeric: true });
      if (i < 0) return 1; if (j < 0) return -1; return i - j;
    });
  }
  // `force` renders even while the focus sits in the bike picker inside the dropdown
  function showEmpty(el, force) {
    if (!el || !el.renderResults || el.getQuery().length) return;
    var render = function (d) { if (el.getQuery().length || (!force && document.activeElement !== el.input)) return; el.renderResults(renderEmptyBox(d)); };
    if (emptyCache.data && Date.now() - emptyCache.at < 5 * 60 * 1000) { render(emptyCache.data); return; }
    fetchJSON('/search/suggest', {}, 3000).then(function (d) { emptyCache = { at: Date.now(), data: d }; render(d); })
      .catch(function () { render({ popular: [], trending: [] }); });
  }
  function wireEmptyBox(el) {
    if (!el || el.__tbhEmpty || !el.input) return;
    el.__tbhEmpty = true;
    el.input.addEventListener('focus', function () { if (!el.getQuery().length) showEmpty(el); });
    el.input.addEventListener('input', function () { if (!el.getQuery().length) setTimeout(function () { showEmpty(el); }, 380); });
    // the bike picker lives inside the dropdown; its keys must not reach the element's own handlers
    el.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t.closest('[data-tbh-bike-clear]')) { ev.preventDefault(); saveBike(null); emptyCache.at = 0; showEmpty(el, true); return; }
      if (t.closest('[data-tbh-bike-change]')) {
        ev.preventDefault();
        var row = el.querySelector('[data-tbh-bike-row]'); if (!row) return;
        row.innerHTML = '<div class="tbh-eb__pick"><input type="search" placeholder="Your bike, e.g. Merida Scultura Rim 100 or Polygon Path 3" aria-label="Find your bike" data-tbh-bike-q autocomplete="off"><ul data-tbh-bike-list></ul></div>';
        var inp = row.querySelector('[data-tbh-bike-q]'), list = row.querySelector('[data-tbh-bike-list]');
        ['keydown', 'keyup', 'input'].forEach(function (k) { inp.addEventListener(k, function (e) { e.stopPropagation(); }); });
        var timer = null;
        inp.addEventListener('input', function () {
          clearTimeout(timer);
          var v = inp.value.trim(); if (v.length < 2) { list.innerHTML = ''; return; }
          timer = setTimeout(function () {
            // Three sources (the chat app's /search/bike-find): bikes we sell, bikes from the
            // library of outside bikes, and the words themselves as a bike of their own.
            fetchJSON('/search/bike-find', { q: v }, 3000).then(function (d) {
              var facts = function (b) {
                var f = [];
                if (b.speeds && b.speeds.length) f.push(b.speeds.join('/') + '-speed');
                if (b.wheel) f.push(wheelLabel(b.wheel));
                if (b.brakes) f.push(b.brakes + ' brakes');
                return f.length ? '<span class="tbh-eb__facts">' + esc(f.join(' · ')) + '</span>' : '';
              };
              var html = '';
              if ((d.store || []).length) html += '<li class="tbh-eb__grp">Bikes we sell</li>' + d.store.map(function (p) { return '<li><button type="button" data-tbh-bike-pick="' + esc(p.handle) + '">' + esc(p.title) + '</button></li>'; }).join('');
              if ((d.library || []).length) html += '<li class="tbh-eb__grp">Other bikes</li>' + d.library.map(function (b) { return '<li><button type="button" data-tbh-bike-lib="' + esc(b.id) + '">' + esc(b.title) + facts(b) + '</button></li>'; }).join('');
              if (d.typed) html += '<li class="tbh-eb__grp">Not listed?</li><li><button type="button" data-tbh-bike-typed="' + esc(d.typed.title) + '">Use \u201c' + esc(d.typed.title) + '\u201d as my bike' + facts(d.typed) + '</button></li>';
              list.innerHTML = html || '<li><small>Type the brand and model of your bike.</small></li>';
            }).catch(function () { list.innerHTML = ''; });
          }, 250);
        });
        setTimeout(function () { inp.focus(); }, 30);
        return;
      }
      var keep = function (b) {
        saveBike({ source: b.source || 'store', handle: b.handle || null, id: b.id || null, title: b.title, url: b.url || null,
                   speeds: b.speeds || [], wheel: b.wheel || null, brakes: b.brakes || null, sizes: b.sizes || [], size: null });
        emptyCache.at = 0; showEmpty(el, true);
      };
      var pick = t.closest('[data-tbh-bike-pick]');
      if (pick) {
        ev.preventDefault();
        fetchJSON('/search/bike', { handle: pick.getAttribute('data-tbh-bike-pick') }, 4000).then(keep).catch(function () { /* leave the picker as it is */ });
        return;
      }
      var lib = t.closest('[data-tbh-bike-lib]');
      if (lib) {
        ev.preventDefault();
        fetchJSON('/search/bike', { lib: lib.getAttribute('data-tbh-bike-lib') }, 4000).then(keep).catch(function () {});
        return;
      }
      // A bike in neither list: three optional picks, filled in from what the words said.
      var typed = t.closest('[data-tbh-bike-typed]');
      if (typed) {
        ev.preventDefault();
        var name = typed.getAttribute('data-tbh-bike-typed');
        fetchJSON('/search/bike', { typed: name }, 4000).then(function (b) {
          var opt = function (v, label, cur) { return '<option value="' + v + '"' + (String(cur) === v ? ' selected' : '') + '>' + label + '</option>'; };
          var sp = (b.speeds || [])[0] || '';
          var box = el.querySelector('.tbh-eb__pick'); if (!box) return;
          box.innerHTML = '<div><b>' + esc(b.title) + '</b> <small>All three are optional. Each one you set helps the right parts show first.</small></div>' +
            '<div class="tbh-eb__picks">' +
            '<label>Gears at the back<select data-tbh-pick-speeds>' + opt('', "Don\u2019t know", sp) + [7, 8, 9, 10, 11, 12].map(function (n) { return opt(String(n), n + '-speed', sp); }).join('') + '</select></label>' +
            '<label>Wheel size<select data-tbh-pick-wheel>' + opt('', "Don\u2019t know", b.wheel || '') + [['700', '700c'], ['650', '650b'], ['29', '29"'], ['27.5', '27.5"'], ['26', '26"']].map(function (w) { return opt(w[0], w[1], b.wheel || ''); }).join('') + '</select></label>' +
            '<label>Brakes<select data-tbh-pick-brakes>' + opt('', "Don\u2019t know", b.brakes || '') + opt('rim', 'Rim', b.brakes || '') + opt('disc', 'Disc', b.brakes || '') + '</select></label>' +
            '<button type="button" class="tbh-eb__save" data-tbh-bike-save="' + esc(b.title) + '">Save my bike</button></div>';
          box.querySelectorAll('select').forEach(function (x) { ['keydown', 'keyup', 'input', 'change'].forEach(function (k) { x.addEventListener(k, function (e) { e.stopPropagation(); }); }); });
        }).catch(function () {});
        return;
      }
      var save = t.closest('[data-tbh-bike-save]');
      if (save) {
        ev.preventDefault();
        var box2 = save.closest('.tbh-eb__pick');
        var val = function (sel) { var x = box2 && box2.querySelector(sel); return x ? x.value : ''; };
        fetchJSON('/search/bike', { typed: save.getAttribute('data-tbh-bike-save'), save: 1, speeds: val('[data-tbh-pick-speeds]'),
          wheel: val('[data-tbh-pick-wheel]'), brakes: val('[data-tbh-pick-brakes]') }, 4000).then(keep).catch(function () {});
      }
    });
    el.addEventListener('change', function (ev) {
      var sel = ev.target.closest && ev.target.closest('[data-tbh-bike-size]');
      if (!sel) return;
      var b = myBike(); if (!b) return;
      b.size = sel.value || null; saveBike(b);
    });
  }
  function wireAllBoxes() { document.querySelectorAll('predictive-search').forEach(wireEmptyBox); }

  function patchPredictive() {
    var Ctor = customElements.get('predictive-search');
    if (!Ctor || Ctor.prototype.__tbhPatched) return;
    Ctor.prototype.__tbhPatched = true;
    var original = Ctor.prototype.getResults;
    Ctor.prototype.getResults = function (term) {
      var self = this;
      if (self.setLiveRegionLoadingState) self.setLiveRegionLoadingState();
      var scoped = pageCollection && self.closest('[data-tbh-search]') ? pageCollection : '';
      var key = (scoped ? scoped + '|' : '') + term.toLowerCase();
      if (suggestCache[key]) { self.renderResults(suggestCache[key]); return Promise.resolve(); }
      return fetchJSON('/search/suggest', scoped ? { q: term, collection: scoped } : { q: term }, 3000).then(function (data) {
        if (self.getQuery && self.getQuery() !== term) return;      // the box moved on
        var markup = renderSuggest(data, self.input.id, term);
        suggestCache[key] = markup;
        self.renderResults(markup);
      }).catch(function () { return original.call(self, term); });
    };
  }
  if (customElements.get('predictive-search')) { patchPredictive(); wireAllBoxes(); }
  else if (window.customElements) customElements.whenDefined('predictive-search').then(function () { patchPredictive(); wireAllBoxes(); });
  // header boxes that arrive later (a drawer rendered on open)
  document.addEventListener('DOMContentLoaded', wireAllBoxes);
  document.addEventListener('on:drawer:opened', wireAllBoxes);

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('[data-tbh-click]');
    if (!a) return;
    var term = a.getAttribute('data-tbh-q') || '';
    if (term) beacon(term, a.getAttribute('data-tbh-click'), Number(a.getAttribute('data-tbh-pos')) || null);
    rememberClick(term || '(empty box)', a.getAttribute('data-tbh-click'));
  }, true);

  // ---- 2. the results page --------------------------------------------------
  var root = document.querySelector('[data-tbh-search]');
  if (!root) return;
  var q = root.getAttribute('data-q') || '';
  var pageSize = Number(root.getAttribute('data-page-size')) || 20;
  var fallbackSel = root.getAttribute('data-fallback') || '.shopify-section.cc-main-search';
  var els = {
    summary: root.querySelector('[data-tbh-summary]'), chips: root.querySelector('[data-tbh-chips]'),
    grid: root.querySelector('[data-tbh-grid]'), more: root.querySelector('[data-tbh-more]'),
    empty: root.querySelector('[data-tbh-empty]'), toolbar: root.querySelector('[data-tbh-toolbar]'),
    sort: root.querySelector('[data-tbh-sort]'), results: root.querySelector('[data-tbh-results]'),
    related: root.querySelector('[data-tbh-related]'), relatedGrid: root.querySelector('[data-tbh-related-grid]'),
    guides: root.querySelector('[data-tbh-guides]'),
  };
  function showShopify(on) {
    var el = null;
    try { el = document.querySelector(fallbackSel); } catch (e) { el = null; }
    if (el) { el.hidden = !on; el.style.display = on ? '' : 'none'; }
    var style = document.getElementById('tbh-hide-shopify-search');
    if (style && on) style.remove();
    root.hidden = on;                    // one title, one box, one set of results -- never both
    if (!on) window.__tbhSearchReady = true;
  }
  if (!q) { showShopify(true); return; }
  window.__tbhSearchReady = true;        // the watchdog in the section stands down; failures hand over explicitly
  rememberSearch(q);

  var st = {
    q: q, page: 1, sort: qs.get('sort') || 'relevance', exact: qs.get('exact') === '1',
    vendor: split(qs.get('vendor')), type: split(qs.get('type')), price: split(qs.get('price')), size: split(qs.get('size')),
    in_stock: qs.get('in_stock') === '1', on_sale: qs.get('on_sale') === '1',
    bike: qs.get('bike') !== '0',          // "For my bike" is on whenever a bike is saved, until switched off
    collection: pageCollection,            // a search "in" one collection (see the top of the file)
  };
  // the page's own search box keeps the scope when the shopper searches again
  if (st.collection) {
    var scopedForm = root.querySelector('form.search, form[role="search"]');
    if (scopedForm && !scopedForm.querySelector('input[name="collection"]')) {
      [['collection', st.collection], ['ct', pageCollectionTitle]].forEach(function (kv) {
        if (!kv[1]) return;
        var h = document.createElement('input'); h.type = 'hidden'; h.name = kv[0]; h.value = kv[1]; scopedForm.appendChild(h);
      });
    }
  }
  var busy = false, hasMore = false, failed = false;

  function params() {
    var p = { q: st.q, page: st.page, limit: pageSize, sort: st.sort, exact: st.exact ? '1' : '',
      vendor: st.vendor.join('|'), type: st.type.join('|'), price: st.price.join('|'), size: st.size.join('|'), in_stock: st.in_stock ? '1' : '', on_sale: st.on_sale ? '1' : '' };
    if (st.bike) { var h = bikeHints(myBike()); Object.keys(h).forEach(function (k) { p[k] = h[k]; }); }
    if (st.collection) p.collection = st.collection;
    return p;
  }
  function syncUrl() {
    var u = new URL(location.href), p = params();
    ['sort', 'vendor', 'type', 'price', 'size', 'in_stock', 'on_sale', 'exact', 'page', 'bike'].forEach(function (k) { u.searchParams.delete(k); });
    ['sort', 'vendor', 'type', 'price', 'size', 'in_stock', 'on_sale', 'exact'].forEach(function (k) { if (p[k] && !(k === 'sort' && p[k] === 'relevance')) u.searchParams.set(k, p[k]); });
    if (!st.bike && myBike()) u.searchParams.set('bike', '0');
    try { history.replaceState(null, '', u.toString()); } catch (e) { /* ignore */ }
  }
  function skeleton(n) {
    var s = '';
    for (var i = 0; i < n; i++) s += '<li class="tbh-sf__skel" aria-hidden="true"><div class="tbh-sf__skel-img"></div><div class="tbh-sf__skel-line"></div><div class="tbh-sf__skel-line tbh-sf__skel-line--short"></div></li>';
    return s;
  }
  function renderCards(products, pageBase) {
    var handles = products.map(function (p) { return p.handle; });
    if (!handles.length) return Promise.resolve('');
    var url = '/search?type=product&q=' + encodeURIComponent('handles:' + handles.join(',')) + '&section_id=tba-card-renderer';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('cards HTTP ' + r.status); return r.text(); }).then(function (html) {
      var tpl = document.createElement('template');
      tpl.innerHTML = html;
      var by = {};
      tpl.content.querySelectorAll('[data-tbh-handle]').forEach(function (el) { by[el.getAttribute('data-tbh-handle')] = el.innerHTML; });
      var base = pageBase != null ? pageBase : (st.page - 1) * pageSize;
      var holder = document.createElement('div');
      return products.map(function (p, i) {
        if (!by[p.handle]) return '';
        var card = by[p.handle];
        // one line of facts under the title: "11-speed · Steel", "700c · Tubeless ready"
        if (p.hits && p.hits.length) {
          holder.innerHTML = card;
          var title = holder.querySelector('.card__title');
          if (title) { title.insertAdjacentHTML('afterend', '<p class="tbh-sf__hits">' + p.hits.map(esc).join(' · ') + '</p>'); card = holder.innerHTML; }
        }
        return '<li class="js-pagination-result' + (p.available === false ? ' tbh-sf__item--sold-out' : '') + '" data-tbh-id="' + esc(p.id) + '" data-tbh-pos="' + (base + i + 1) + '">' + card + '</li>';
      }).join('');
    });
  }
  function renderSummary(d) {
    if (!els.summary) return;
    var n = d.total, word = n === 1 ? 'result' : 'results';
    var html = '<b>' + n.toLocaleString('en-IN') + '</b> ' + word + ' for “' + esc(d.q) + '”';
    if (d.corrected) html = '<b>' + n.toLocaleString('en-IN') + '</b> ' + word + ' for “<b>' + esc(d.corrected) + '</b>”. <a class="link" href="/search?q=' + encodeURIComponent(d.q) + '&exact=1">Search instead for “' + esc(d.q) + '”</a>';
    if (d.mode === 'loose' && n) html = 'No exact matches for “' + esc(d.corrected || d.q) + '”. Showing <b>' + n.toLocaleString('en-IN') + '</b> close ' + (n === 1 ? 'match' : 'matches');
    // said only when the API confirmed the scope: an older backend ignores `collection` and
    // answers store-wide, and the page must not then claim otherwise
    if (st.collection && d.collection) {
      var everywhere = '/search?q=' + encodeURIComponent(d.q);
      html += d.collection.scoped === false
        ? ' <span class="tbh-sf__notes">· across the whole store</span>'
        : ' in <b>' + esc(collectionName(d)) + '</b> <a class="link tbh-sf__everywhere" href="' + everywhere + '">Search the whole store</a>';
    }
    var notes = [];
    if (d.budget && d.budget.max && d.budget.min) notes.push(money(d.budget.min) + ' to ' + money(d.budget.max));
    else if (d.budget && d.budget.max) notes.push('under ' + money(d.budget.max));
    else if (d.budget && d.budget.min) notes.push('over ' + money(d.budget.min));
    var P = d.parsed || {};
    if (P.colours && P.colours.length) notes.push('in ' + P.colours.join(' or '));
    if (P.sizes && P.sizes.length) notes.push('size ' + P.sizes.join(' or ').toUpperCase());
    if (P.in_stock) notes.push('in stock');
    if (P.on_sale) notes.push('on sale');
    if (P.sort === 'price-asc') notes.push('cheapest first');
    if (P.sort === 'price-desc') notes.push('dearest first');
    if (d.compat && d.compat.note) notes.push(d.compat.note);
    if (notes.length) html += ' <span class="tbh-sf__notes">· ' + notes.map(esc).join(' · ') + '</span>';
    els.summary.innerHTML = html;
    // the sort control follows a sort the words asked for
    if (els.sort && d.sort) {
      var cs = els.sort.querySelector('custom-select'); var btn = cs && cs.querySelector('.custom-select__btn span, .custom-select__btn');
      var names = { 'relevance': 'Recommended', 'price-asc': 'Price, low to high', 'price-desc': 'Price, high to low', 'discount': 'Biggest discount', 'best-selling': 'Best selling' };
      if (btn && names[d.sort] && st.sort !== d.sort) { st.sort = d.sort; var label = cs.querySelector('.custom-select__btn [data-selected], .custom-select__btn > span'); if (label) label.textContent = names[d.sort]; }
    }
  }
  function chip(dim, value, label, count, active) {
    return '<button type="button" class="tbh-sf__chip' + (active ? ' is-active' : '') + '" data-dim="' + esc(dim) + '" data-value="' + esc(value) + '" aria-pressed="' + (active ? 'true' : 'false') + '">' +
      (active ? '<span aria-hidden="true">✓&nbsp;</span>' : '') + esc(label) + (count != null ? ' <span class="tbh-sf__n">' + esc(count) + '</span>' : '') + '</button>';
  }
  function renderChips(d) {
    if (!els.chips) return;
    // One compact line (Sampath, 2026-10-07): stock and sale, price bands, brands, categories,
    // separated by hairlines, scrolling sideways when there are more than fit.
    var f = d.facets || {}, groups = [];
    var top = [];
    var A = d.applied || {};
    if (f.in_stock != null && (f.in_stock < d.total || A.in_stock)) top.push(chip('in_stock', '1', 'In stock only', f.in_stock, !!A.in_stock));
    if (f.on_sale && (f.on_sale < d.total || A.on_sale)) top.push(chip('on_sale', '1', 'On sale', f.on_sale, !!A.on_sale));
    var b = myBike();
    if (b && (b.speeds && b.speeds.length || b.wheel || b.size || b.brakes)) top.push(chip('bike', '1', 'For my ' + (b.title.length > 22 ? 'bike' : b.title), null, st.bike));
    if (top.length) groups.push(top);
    var bands = (f.price || []).map(function (b) { return chip('price', b.value, b.label, b.count, st.price.indexOf(b.value) >= 0); });
    if (bands.length > 1 || st.price.length) groups.push(bands);
    var brands = (f.vendor || []).slice(0, 10).map(function (v) { return chip('vendor', v.value, v.value, v.count, st.vendor.indexOf(v.value) >= 0); });
    if (brands.length > 1 || st.vendor.length) groups.push(brands);
    var types = (f.type || []).slice(0, 10).map(function (v) { return chip('type', v.value, v.value, v.count, st.type.indexOf(v.value) >= 0); });
    if (types.length > 1 || st.type.length) groups.push(types);
    els.chips.innerHTML = groups.length ? '<div class="tbh-sf__row">' + groups.map(function (g) { return '<div class="tbh-sf__group">' + g.join('') + '</div>'; }).join('') + '</div>' : '';
  }
  function renderGuides(d) {
    if (!els.guides) return;
    var list = (d.content || []).slice(0, 4);
    els.guides.hidden = !list.length;
    els.guides.innerHTML = list.length ? '<div class="tbh-sf__guides-row"><span class="tbh-sf__guides-k">' + esc(els.guides.getAttribute('data-label') || 'Guides & pages') + '</span>' +
      list.map(function (g) { return '<a class="tbh-sf__guide" href="' + esc(g.url) + '" title="' + esc(g.title) + '"><span class="tbh-sf__kind">' + esc(g.kind) + '</span>' + esc(g.title) + '</a>'; }).join('') + '</div>' : '';
  }
  function renderEmpty(d) {
    if (!els.empty) return;
    var scopedHere = st.collection && d.collection && d.collection.scoped !== false;
    var html = '<h2>No results for “' + esc(d.q) + '”' + (scopedHere ? ' in ' + esc(collectionName(d)) : '') + '</h2>';
    if (scopedHere) html += '<p><a class="link" href="/search?q=' + encodeURIComponent(d.q) + '">Search the whole store for “' + esc(d.q) + '”</a></p>';
    if (d.corrected) html += '<p>We searched for “' + esc(d.corrected) + '” too.</p>';
    html += '<p>Check the spelling, try fewer words, or browse the categories below.</p>' +
      '<div class="tbh-sf__links"><a class="link" href="' + esc(askGuideHref(d.q)) + '">Ask TBA Guide about “' + esc(d.q) + '”</a><a class="link" href="/collections">All categories</a></div>';
    els.empty.innerHTML = html;
  }
  // An owner's redirect: "warranty" lands on the warranty page, not a grid. Never when the
  // shopper asked for the exact words, never twice, never to the page we are on.
  var redirected = false;
  function followRedirect(d) {
    if (!d.redirect || redirected || st.exact || st.page !== 1 || qs.get('noredirect') === '1') return false;
    var to; try { to = new URL(d.redirect, location.origin); } catch (e) { return false; }
    if (to.origin !== location.origin || to.pathname === location.pathname) return false;
    redirected = true;
    if (els.summary) els.summary.innerHTML = 'Taking you to <a class="link" href="' + esc(to.href) + '">' + esc(to.pathname) + '</a>…';
    location.replace(to.href);
    return true;
  }
  function load(append) {
    if (busy) return;
    busy = true;
    root.classList.add('is-loading');
    if (!append) { st.page = 1; if (els.grid) els.grid.innerHTML = skeleton(Math.min(pageSize, 8)); }
    /* MORE, as the shopper scrolls (Sampath, 2026-10-28: the category pages scroll on forever and the
       button here showed no sign of loading). Four placeholder cards sit at the end of the grid while
       the next page is on its way; the button only appears again if a page fails, as a retry. */
    else if (els.grid) { els.grid.insertAdjacentHTML('beforeend', skeleton(4).replace(/tbh-sf__skel"/g, 'tbh-sf__skel tbh-sf__skel--more"')); if (els.more) els.more.hidden = true; }
    function dropSkeletons() { if (els.grid) els.grid.querySelectorAll('.tbh-sf__skel--more').forEach(function (n) { n.remove(); }); }
    fetchJSON('/search/products', params(), 6000).then(function (d) {
      if (!append && followRedirect(d)) return;
      var related = (!append && d.page === 1 && d.related && d.related.length) ? d.related : [];
      return Promise.all([renderCards(d.products), related.length ? renderCards(related, 1000) : Promise.resolve('')]).then(function (parts) {
        var html = parts[0], relatedHtml = parts[1];
        if (!append && els.grid) els.grid.innerHTML = '';
        dropSkeletons();
        if (els.grid) els.grid.insertAdjacentHTML('beforeend', html);
        if (els.related) {
          els.related.hidden = !relatedHtml;
          if (els.relatedGrid) els.relatedGrid.innerHTML = relatedHtml;
        }
        renderSummary(d); renderChips(d);
        if (!append) renderGuides(d);
        hasMore = d.page < d.pages;
        if (els.more) els.more.hidden = true;   /* scrolling loads the next page; the button is only a retry */
        if (els.empty) { els.empty.hidden = d.total > 0; if (!d.total) renderEmpty(d); }
        if (els.toolbar) els.toolbar.hidden = d.total === 0;
        syncUrl();
        showShopify(false);
        document.dispatchEvent(new CustomEvent('tbh:search:rendered', { detail: d }));
      });
    }).catch(function (e) {
      if (append) {
        /* A later page failed: keep what is on screen and offer the button as a retry. */
        dropSkeletons(); st.page -= 1; failed = true;
        if (els.more) els.more.hidden = false;
        return;
      }
      // Shopify's own results are on the page already, hidden: the safe thing is to show them.
      if (window.console) console.warn('TBA search: showing the theme results instead —', e && e.message);
      showShopify(true);
    }).finally(function () { busy = false; root.classList.remove('is-loading'); setTimeout(nearEnd, 60); });
  }

  if (els.chips) els.chips.addEventListener('click', function (ev) {
    var b = ev.target.closest('.tbh-sf__chip'); if (!b) return;
    var dim = b.getAttribute('data-dim'), v = b.getAttribute('data-value');
    if (dim === 'in_stock') st.in_stock = b.getAttribute('aria-pressed') !== 'true';
    else if (dim === 'on_sale') st.on_sale = b.getAttribute('aria-pressed') !== 'true';
    else if (dim === 'bike') st.bike = b.getAttribute('aria-pressed') !== 'true';
    else { var i = st[dim].indexOf(v); if (i >= 0) st[dim].splice(i, 1); else st[dim].push(v); }
    load(false);
  });
  if (els.sort) els.sort.addEventListener('change', function (ev) {
    var v = (ev.detail && ev.detail.selectedValue) || (ev.target && ev.target.value);
    if (!v || v === st.sort) return;
    st.sort = v; load(false);
  });
  if (els.more) els.more.addEventListener('click', function () { failed = false; st.page += 1; load(true); });
  /* Load the next page when the end of the grid comes within 800px of the bottom of the screen.
     Checked from scroll events through a short timer, like the rest of this theme's scroll work
     (IntersectionObserver and rAF do not fire in a hidden preview pane). After a failure it waits
     for the retry button. */
  function nearEnd() {
    if (busy || !hasMore || failed || !els.grid || !els.grid.children.length || root.hidden) return;
    if (els.grid.getBoundingClientRect().bottom - window.innerHeight < 800) { st.page += 1; load(true); }
  }
  var nearT;
  window.addEventListener('scroll', function () { clearTimeout(nearT); nearT = setTimeout(nearEnd, 100); }, { passive: true });
  var compareSwitch = root.querySelector('#compare-switch');
  if (compareSwitch) compareSwitch.addEventListener('change', function () {
    var grid = root.querySelector('.main-products-grid'); if (grid) grid.dataset.compare = compareSwitch.checked;
  });
  function cardClick(ev) {
    var li = ev.target.closest('li[data-tbh-id]'); var a = ev.target.closest('a');
    if (li && a) { beacon(st.q, li.getAttribute('data-tbh-id'), Number(li.getAttribute('data-tbh-pos')) || null); rememberClick(st.q, li.getAttribute('data-tbh-id')); }
  }
  if (els.grid) els.grid.addEventListener('click', cardClick, true);
  if (els.relatedGrid) els.relatedGrid.addEventListener('click', cardClick, true);
  // the bike changed in the header box while this page is open: search again with it
  document.addEventListener('tbh:bike', function () { if (st.bike) load(false); });

  load(false);
})();

/*
 * THE PAGE MUST NOT MOVE WHILE SOMEONE TYPES IN THE SEARCH BOX (Sampath, 2026-10-14: "the page in
 * the background scrolls up with every letter typed").
 * Nothing in our code or the theme's scrolls it: Chrome does, natively. The box lives in the
 * header, which is position: sticky; on every keystroke (and on the focus when the phone's search
 * icon opens it) Chrome "reveals" the caret as though the header sat where it would be UNSTUCK,
 * and scrolls the page toward it: 28 px per letter on a phone, ~700 px on opening. The theme's
 * overflow: hidden on body (overlay-predictive-search) does not stop a programmatic scroll.
 * So while a header search box has the focus, a page scroll the shopper did not make (no wheel,
 * finger drag or key in the last 700 ms) is put straight back. Scroll events run before paint, so
 * nothing visibly jumps. A scroll the shopper does make is left alone.
 */
(function () {
  var lastY = window.scrollY, userAt = 0;
  function user() { userAt = Date.now(); }
  // a tap is not a scroll: the tap on the search icon is what sets off the jump on opening
  ['wheel', 'touchmove', 'keydown'].forEach(function (t) {
    window.addEventListener(t, function (e) {
      // typing in the box is not the shopper scrolling (Page Down elsewhere is). Each keystroke
      // also notes where the page is BEFORE Chrome moves it, so the put-back target is right
      // even if a scroll event was missed.
      if (t === 'keydown' && e.target && e.target.classList && e.target.classList.contains('js-search-input')) { lastY = window.scrollY; return; }
      user();
    }, { passive: true, capture: true });
  });
  function typing() {
    var a = document.activeElement;
    return !!(a && a.classList && a.classList.contains('js-search-input'));
  }
  // The phone's search icon opens the bar and calls input.focus() (theme main.js) with no
  // preventScroll: that focus is the ~700 px jump. Every header search box focuses without
  // scrolling instead. This one does not rely on scroll events, so it holds even when they lag.
  Array.prototype.forEach.call(document.querySelectorAll('.js-search-input'), function (inp) {
    // where the page is just BEFORE Chrome moves it: on focus, and before every character
    inp.addEventListener('focus', function () { lastY = window.scrollY; });
    inp.addEventListener('beforeinput', function () { lastY = window.scrollY; });
    inp.focus = function (opts) {
      var o = {}; if (opts) for (var k in opts) o[k] = opts[k];
      o.preventScroll = true;
      return HTMLElement.prototype.focus.call(this, o);
    };
  });
  window.addEventListener('scroll', function () {
    // Chrome's keystroke jumps are 28-150 px; anything past 400 px is not one of them, and putting
    // the page back that far could only be a stale lastY, so it is left alone
    var moved = Math.abs(window.scrollY - lastY);
    if (typing() && Date.now() - userAt > 700 && moved > 1 && moved < 400) {
      window.scrollTo({ top: lastY, behavior: 'instant' });
      return;
    }
    lastY = window.scrollY;
  }, { passive: true });
})();

/*
 * THE "COMPARE (n)" BUTTON ONLY WHERE IT MEANS SOMETHING (2026-10-23, from the competitor
 * review). The theme keeps ONE compare list for the whole site (localStorage cc-compare-products)
 * and shows its floating button on every page while the list has anything in it, so two road
 * bikes compared yesterday followed the shopper onto the helmets page. The button now shows only
 * where at least one compared product is on the page; ticking a product here shows it at once.
 * The list itself is untouched, so going back to the bikes brings the button back.
 * CSS (tba-home.css) hides .js-open-compare-drawer unless <html> has .tbh-cmp-here.
 */
(function () {
  function ids() {
    try { return (JSON.parse(localStorage.getItem('cc-compare-products') || '[]') || []).map(function (p) { return String(p.id); }); }
    catch (e) { return []; }
  }
  function check() {
    var list = ids(), here = false;
    if (list.length) {
      var cards = document.querySelectorAll('[data-product-id]');
      for (var i = 0; i < cards.length && !here; i++) if (list.indexOf(String(cards[i].getAttribute('data-product-id'))) >= 0) here = true;
    }
    document.documentElement.classList.toggle('tbh-cmp-here', here);
  }
  check();
  document.addEventListener('DOMContentLoaded', check);
  document.addEventListener('change', function () { setTimeout(check, 60); });
  document.addEventListener('on:facet-filters:updated', function () { setTimeout(check, 60); });
})();
